import React, { useState } from 'react';
import { CheckIcon, ShieldCheckIcon, StarIcon, ChevronDownIcon, CreditCardIcon, DownloadIcon, LockIcon, InfinityIcon } from 'lucide-react';
// Images
const IMAGES = {
  PRODUCT: 'https://cdn.magicpatterns.com/uploads/2DA9hWKwkkqHXfEifZ3MYh/MOCKUPS_MATEMATICA_.png',
  BONUS_1: 'https://cdn.magicpatterns.com/uploads/mE35zWJ1YGWNbdPkUgbRgb/BONUS_1_MATEMATICA_.png',
  BONUS_2: 'https://cdn.magicpatterns.com/uploads/aadRmnjLpbMSJ2m27dLmYb/BONUS_2_MATEMATICA_.png',
  UPSELL: 'https://cdn.magicpatterns.com/uploads/bn2ps4kH4ETNy1495hN4s3/UPSELL_MATEMATICA_.png'
};
// Links
const LINKS = {
  MAIN_CHECKOUT: 'https://mi-tienda-pro-8012.myshopify.com/cart/48248976998619:1',
  UPSELL_CHECKOUT: 'https://mi-tienda-pro-8012.myshopify.com/cart/48248979488987:1'
};
export function SalesPage() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-white selection:bg-yellow-200 selection:text-black" data-id="element-8">
      {/* 2. HERO SECTION */}
      <section className="bg-white pt-1 pb-2 px-4 md:px-6 border-b-4 border-gray-200" data-id="element-9">
        <div className="max-w-4xl mx-auto text-center" data-id="element-10">
          <p className="text-sm md:text-base font-bold text-gray-600 uppercase tracking-widest mb-0" data-id="element-11">
            PARA MAESTRAS DE MATEMÁTICA PRIMARIA
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-0" data-id="element-12">
            Organizá todo tu año de Matemática y ahorrá hasta 12 meses de
            planificación con el{' '}
            <span className="text-[#27ae60]" data-id="element-13">Mega Pack Matemática Lista</span>
          </h1>

          <div className="flex justify-center cursor-pointer hover:scale-[1.02] transition-transform duration-300 -mt-6 -mb-6 md:-mt-8 md:-mb-8" onClick={scrollToPricing} data-id="element-14">
            <img src={IMAGES.PRODUCT} alt="Mega Pack Matemática Lista Completo" className="w-full max-w-lg object-contain" data-id="element-15" />
          </div>

          <h2 className="text-xl md:text-2xl font-medium text-gray-700 max-w-3xl mx-auto mb-3" data-id="element-16">
            Sistema completo de clases, actividades y proyectos de Matemática
            listos para usar. <br className="hidden md:block" data-id="element-17" />
            <span className="font-bold bg-yellow-100 px-1" data-id="element-18">
              Todo tu año resuelto (todos los grados de primaria)
            </span>
          </h2>

          <button onClick={scrollToPricing} className="inline-block bg-[#27ae60] hover:bg-[#219a52] text-white text-xl md:text-3xl font-black py-5 px-8 md:px-12 rounded shadow-[0_4px_0_rgb(24,120,60)] active:shadow-none active:translate-y-[4px] transition-all transform hover:scale-105 animate-pulse-slow w-full md:w-auto mb-3" data-id="element-19">
            👉 SÍ, QUIERO ACCESO INMEDIATO
          </button>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs md:text-sm font-semibold text-gray-500" data-id="element-20">
            <div className="flex items-center gap-1" data-id="element-21">
              <LockIcon size={16} data-id="element-22" /> Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-23">
              <DownloadIcon size={16} data-id="element-24" /> Descarga inmediata
            </div>
            <div className="flex items-center gap-1" data-id="element-25">
              <ShieldCheckIcon size={16} data-id="element-26" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1" data-id="element-27">
              <InfinityIcon size={16} data-id="element-28" /> Acceso de por vida
            </div>
          </div>
        </div>
      </section>

      {/* 3. PAIN POINTS SECTION */}
      <section className="bg-gray-900 text-white py-10 px-4 md:px-6" data-id="element-29">
        <div className="max-w-3xl mx-auto" data-id="element-30">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-yellow-400" data-id="element-31">
            Si sos maestra de Matemática, esto te va a sonar familiar…
          </h2>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-200" data-id="element-32">
            <p data-id="element-33">
              Llegás del colegio agotada y todavía tenés que planificar. Horas
              buscando ejercicios adecuados, armando secuencias didácticas,
              diseñando evaluaciones claras, creando actividades que realmente
              enganchen a tus alumnos…
            </p>
            <p data-id="element-34">
              No es falta de capacidad.{' '}
              <span className="font-bold text-white bg-red-600/20 px-1" data-id="element-35">
                Es que te falta un sistema integral que te sostenga todo el año
                escolar.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* 4. SOLUTION SECTION */}
      <section className="bg-white py-10 px-4 md:px-6" data-id="element-36">
        <div className="max-w-4xl mx-auto text-center" data-id="element-37">
          <p className="text-gray-500 font-bold uppercase tracking-widest mb-1" data-id="element-38">
            La Solución
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-[#2c3e50] mb-3" data-id="element-39">
            MEGA PACK MATEMÁTICA LISTA™
          </h2>
          <p className="text-xl text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-40">
            Sistema completo de clases, actividades, proyectos y evaluaciones ya
            probadas en aula primaria.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-41">
            {['Listo', 'Probado', 'Organizado', 'Usable'].map(item => <div key={item} className="flex items-center gap-2 bg-green-50 px-4 py-2 rounded-full border border-green-200" data-id="element-42">
                <CheckIcon className="text-green-600 w-5 h-5" strokeWidth={3} data-id="element-43" />
                <span className="font-bold text-green-800" data-id="element-44">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. WHAT'S INCLUDED - GRADES */}
      <section className="bg-gray-50 py-10 px-4 md:px-6" data-id="element-45">
        <div className="max-w-4xl mx-auto" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-8" data-id="element-47">
            📘 ¿QUÉ INCLUYE EL MEGA PACK MATEMÁTICA LISTA™?
          </h2>

          <div className="grid gap-4 mb-8" data-id="element-48">
            {[{
            grade: '1.º GRADO',
            color: 'border-l-orange-500',
            icon: '🟠',
            text: 'Bases sólidas: numeración, suma, resta y problemas simples.'
          }, {
            grade: '2.º GRADO',
            color: 'border-l-blue-500',
            icon: '🔵',
            text: 'Operaciones avanzadas, cálculo mental y resolución de problemas.'
          }, {
            grade: '3.º GRADO',
            color: 'border-l-green-500',
            icon: '🟢',
            text: 'Multiplicación y división comprensiva con aplicaciones reales.'
          }, {
            grade: '4.º GRADO',
            color: 'border-l-yellow-500',
            icon: '🟡',
            text: 'Números grandes, fracciones y operaciones estructuradas.'
          }, {
            grade: '5.º GRADO',
            color: 'border-l-red-500',
            icon: '🔴',
            text: 'Decimales, problemas de varios pasos y pensamiento matemático avanzado.'
          }].map(item => <div key={item.grade} className={`bg-white p-6 rounded shadow-sm border-l-8 ${item.color} flex flex-col md:flex-row md:items-center gap-4`} data-id="element-49">
                <div className="text-xl font-black whitespace-nowrap min-w-[140px]" data-id="element-50">
                  {item.icon} {item.grade}
                </div>
                <p className="text-lg text-gray-700" data-id="element-51">{item.text}</p>
              </div>)}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-52">
            {['Planificación anual lista', 'Evaluaciones y seguimiento', 'Secuencias y proyectos aplicados', 'Material editable y listo para usar'].map(feature => <div key={feature} className="flex items-center gap-3" data-id="element-53">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-54">
                  <CheckIcon className="w-5 h-5 text-green-600" strokeWidth={3} data-id="element-55" />
                </div>
                <span className="font-bold text-gray-800" data-id="element-56">{feature}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. EXTRA CTA */}
      <section className="bg-white py-6 px-4 text-center" data-id="element-57">
        <button onClick={scrollToPricing} className="inline-block bg-[#27ae60] hover:bg-[#219a52] text-white text-xl md:text-3xl font-black py-5 px-8 md:px-12 rounded shadow-[0_4px_0_rgb(24,120,60)] active:shadow-none active:translate-y-[4px] transition-all transform hover:scale-105 animate-pulse-slow w-full md:w-auto" data-id="element-58">
          🔥 ¡QUIERO ORGANIZAR MI AÑO AHORA!
        </button>
      </section>

      {/* 7. RESULTS SECTION */}
      <section className="bg-white py-10 px-4 md:px-6 border-t border-gray-100" data-id="element-59">
        <div className="max-w-5xl mx-auto" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-8" data-id="element-61">
            Resultados que Transforman
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-62">
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-100" data-id="element-63">
              <h3 className="text-2xl font-bold text-blue-900 mb-4 border-b border-blue-200 pb-3" data-id="element-64">
                Para tus Alumnos
              </h3>
              <ul className="space-y-4" data-id="element-65">
                {['Comprenden desde la práctica', 'Conectan matemática con la vida real', 'Desarrollan razonamiento lógico', 'Participan más en clase', 'Ganan confianza y seguridad'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-66">
                    <CheckIcon className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-67" />
                    <span className="text-lg text-gray-800" data-id="element-68">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-purple-50 p-6 rounded-xl border border-purple-100" data-id="element-69">
              <h3 className="text-2xl font-bold text-purple-900 mb-4 border-b border-purple-200 pb-3" data-id="element-70">
                Para Vos como Maestra
              </h3>
              <ul className="space-y-4" data-id="element-71">
                {['Ahorrás horas de planificación', 'Enseñás con claridad y estructura', 'Tenés todo organizado por grado', 'Llegás sin estrés al cierre del año', 'Recuperás tiempo personal'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-72">
                    <CheckIcon className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-73" />
                    <span className="text-lg text-gray-800" data-id="element-74">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-75">
            <a href={LINKS.MAIN_CHECKOUT} target="_blank" rel="noopener noreferrer" className="inline-block bg-[#27ae60] hover:bg-[#219a52] text-white text-2xl md:text-4xl font-black py-6 px-10 md:px-16 rounded shadow-[0_4px_0_rgb(24,120,60)] active:shadow-none active:translate-y-[4px] transition-all" data-id="element-76">
              👉 QUIERO LOGRAR ESTO
            </a>
          </div>
        </div>
      </section>

      {/* 8. BONUSES SECTION */}
      <section className="bg-[#fff9e6] py-10 px-4 md:px-6 border-y-4 border-yellow-300" data-id="element-77">
        <div className="max-w-4xl mx-auto" data-id="element-78">
          <div className="text-center mb-8" data-id="element-79">
            <span className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm mb-4 animate-bounce" data-id="element-80">
              SOLO POR HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-2" data-id="element-81">
              🎁 BONOS GRATIS HOY
            </h2>
            <p className="text-xl text-gray-600" data-id="element-82">
              Te llevás 2 bonos exclusivos
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-83">
            {/* Bonus 1 */}
            <div className="bg-white p-5 rounded-xl shadow-lg border-2 border-dashed border-yellow-400 flex flex-col" data-id="element-84">
              <div className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full self-start mb-3" data-id="element-85">
                BONO 1 – GRATIS
              </div>
              <div className="mb-3 cursor-pointer hover:opacity-90 transition-opacity" onClick={scrollToPricing} data-id="element-86">
                <img src={IMAGES.BONUS_1} alt="Planificación Anual Lista" className="w-full aspect-square object-contain bg-gray-50 rounded-lg" data-id="element-87" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-88">
                PLANIFICACIÓN ANUAL LISTA
              </h3>
              <p className="text-gray-600" data-id="element-89">
                Organizá todo el año escolar con una planificación clara, simple
                y adaptable, sin estrés y sin empezar de cero.
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white p-5 rounded-xl shadow-lg border-2 border-dashed border-yellow-400 flex flex-col" data-id="element-90">
              <div className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full self-start mb-3" data-id="element-91">
                BONO 2 – GRATIS
              </div>
              <div className="mb-3 cursor-pointer hover:opacity-90 transition-opacity" onClick={scrollToPricing} data-id="element-92">
                <img src={IMAGES.BONUS_2} alt="Evaluaciones y Seguimiento" className="w-full aspect-square object-contain bg-gray-50 rounded-lg" data-id="element-93" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-94">
                Evaluaciones y Seguimiento sin Estrés
              </h3>
              <p className="text-gray-600" data-id="element-95">
                Instrumentos simples y claros para evaluar y registrar avances
                sin perder tiempo ni improvisar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 9. PRICING SECTION */}
      <section id="pricing-section" className="bg-white py-10 px-4 md:px-6" data-id="element-96">
        <div className="max-w-3xl mx-auto" data-id="element-97">
          <div className="border-4 border-dashed border-red-500 rounded-2xl p-5 md:p-10 bg-red-50/30 relative overflow-hidden" data-id="element-98">
            <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-8 py-2 transform rotate-45 translate-x-8 translate-y-4 shadow-md" data-id="element-99">
              OFERTA LIMITADA
            </div>

            <div className="text-center mb-6" data-id="element-100">
              <h2 className="text-2xl md:text-3xl font-black text-red-600 mb-2" data-id="element-101">
                🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
              </h2>
              <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-102">
                MEGA PACK MATEMÁTICA LISTA™
              </h3>
              <p className="text-xl font-bold text-gray-600" data-id="element-103">
                5 Tomos Base + 2 Bonos PRO
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-104">
              {['Pago único', 'Acceso de por vida', 'Descarga inmediata', 'Garantía 7 días', '2 Bonos incluidos'].map(item => <span key={item} className="bg-white border border-gray-200 px-3 py-1 rounded text-sm font-medium text-gray-600 shadow-sm" data-id="element-105">
                  ✔ {item}
                </span>)}
            </div>

            <div className="text-center mb-8" data-id="element-106">
              <p className="text-gray-500 text-lg mb-1" data-id="element-107">
                Precio regular{' '}
                <span className="line-through decoration-red-500 decoration-2" data-id="element-108">
                  $49.990 ARS
                </span>
              </p>
              <p className="text-6xl md:text-7xl font-black text-green-600 tracking-tight mb-2" data-id="element-109">
                $19.990{' '}
                <span className="text-2xl font-bold text-gray-500" data-id="element-110">ARS</span>
              </p>
              <p className="text-sm text-gray-500 font-medium" data-id="element-111">
                Pago único · Pagarás en pesos argentinos
              </p>
            </div>

            <div className="text-center" data-id="element-112">
              <a href={LINKS.MAIN_CHECKOUT} target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-[#27ae60] hover:bg-[#219a52] text-white text-2xl md:text-4xl font-black py-6 px-8 md:px-16 rounded shadow-[0_4px_0_rgb(24,120,60)] active:shadow-none active:translate-y-[4px] transition-all transform hover:scale-105 animate-pulse-slow mb-6" data-id="element-113">
                👉 SÍ, QUIERO EL MEGA PACK
              </a>

              <div className="flex flex-col items-center gap-2" data-id="element-114">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wide" data-id="element-115">
                  Métodos de pago seguros
                </p>
                <div className="flex items-center gap-4 text-gray-400 grayscale opacity-70" data-id="element-116">
                  <span className="font-bold" data-id="element-117">MERCADO PAGO</span>
                  <CreditCardIcon size={24} data-id="element-118" />
                  <span className="font-bold" data-id="element-119">VISA</span>
                  <span className="font-bold" data-id="element-120">MASTERCARD</span>
                </div>
                <p className="text-xs text-gray-400 mt-1" data-id="element-121">
                  TRANSFERENCIA SOLO POR WHATSAPP
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. UPSELL SECTION */}
      <section className="bg-black text-white py-10 px-4 md:px-6 relative overflow-hidden" data-id="element-122">
        {/* Gold accents */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" data-id="element-123"></div>
        <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" data-id="element-124"></div>

        <div className="max-w-4xl mx-auto" data-id="element-125">
          <div className="text-center mb-8" data-id="element-126">
            <div className="inline-flex items-center gap-2 bg-yellow-500 text-black font-black px-6 py-2 rounded-full text-lg mb-6 shadow-[0_0_20px_rgba(234,179,8,0.6)]" data-id="element-127">
              <StarIcon fill="black" size={20} data-id="element-128" /> MÁS POPULAR
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-129">
              SUPER MEGA PACK COMPLETO
            </h2>
            <p className="text-xl md:text-2xl text-yellow-400 font-bold" data-id="element-130">
              MATEMÁTICA + SISTEMA COMPLETO DE SECUENCIAS Y PROYECTOS
            </p>
          </div>

          <div className="flex flex-col items-center gap-6 mb-8" data-id="element-131">
            <div className="cursor-pointer hover:opacity-90 transition-opacity max-w-md w-full" onClick={() => window.open(LINKS.UPSELL_CHECKOUT, '_blank')} data-id="element-132">
              <img src={IMAGES.UPSELL} alt="Super Mega Pack Completo" className="w-full rounded-lg shadow-[0_0_30px_rgba(255,255,255,0.1)]" data-id="element-133" />
            </div>

            <div className="max-w-lg w-full" data-id="element-134">
              <h3 className="text-2xl font-bold mb-4 text-white border-b border-gray-700 pb-3 text-center" data-id="element-135">
                6 Cuadernillos completos + 3 Bonos
              </h3>
              <ul className="space-y-4 mb-8" data-id="element-136">
                {['Matemática completa', 'Sistema completo de secuencias y proyectos', '3 Bonos incluidos', 'Garantía 7 días'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-137">
                    <CheckIcon className="text-yellow-400 w-6 h-6 flex-shrink-0" strokeWidth={3} data-id="element-138" />
                    <span className="text-lg text-gray-200" data-id="element-139">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 text-center" data-id="element-140">
                <p className="text-gray-400 text-lg mb-1" data-id="element-141">
                  Valor separado{' '}
                  <span className="line-through decoration-red-500" data-id="element-142">
                    $34.990 ARS
                  </span>
                </p>
                <p className="text-5xl md:text-6xl font-black text-yellow-400 mb-2" data-id="element-143">
                  $24.990 <span className="text-xl text-gray-400" data-id="element-144">ARS</span>
                </p>
                <div className="inline-block bg-green-600 text-white font-bold px-3 py-1 rounded text-sm mb-4" data-id="element-145">
                  ¡Ahorrás $10.000 ARS más!
                </div>

                <a href={LINKS.UPSELL_CHECKOUT} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#27ae60] hover:bg-[#219a52] text-white text-xl md:text-2xl font-black py-4 px-6 rounded shadow-[0_4px_0_rgb(24,120,60)] active:shadow-none active:translate-y-[4px] transition-all transform hover:scale-105" data-id="element-146">
                  👉 SÍ, QUIERO EL SUPER MEGA PACK
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 11. GUARANTEE SECTION */}
      <section className="bg-white py-10 px-4 md:px-6" data-id="element-147">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-6 border-4 border-gray-100 p-6 rounded-2xl" data-id="element-148">
          <div className="flex-shrink-0" data-id="element-149">
            <ShieldCheckIcon className="w-32 h-32 text-gray-900" strokeWidth={1} data-id="element-150" />
          </div>
          <div data-id="element-151">
            <h2 className="text-3xl font-black text-gray-900 mb-4" data-id="element-152">
              Garantía de Satisfacción Total
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-153">
              Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
              100%. Sin preguntas.
            </p>
          </div>
        </div>
      </section>

      {/* 12. TESTIMONIALS SECTION */}
      <section className="bg-gray-50 py-10 px-4 md:px-6" data-id="element-154">
        <div className="max-w-4xl mx-auto" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-8" data-id="element-156">
            Testimonios de Maestras en Argentina
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-157">
            {[{
            text: 'Ahora organizo todo el año sin estrés. Es increíble el tiempo que ahorro.',
            author: 'Mariela S.',
            location: 'Córdoba, Argentina'
          }, {
            text: 'Mis alumnos participan más y entienden mejor las operaciones. Me siento más segura enseñando.',
            author: 'Laura M.',
            location: 'Santa Fe, Argentina'
          }, {
            text: 'Las clases cambiaron por completo. Todo está más claro y organizado.',
            author: 'Verónica P.',
            location: 'Buenos Aires, Argentina'
          }, {
            text: 'Llevaba años armando todo desde cero. Con el Mega Pack, en una tarde tenía todo el año planificado. ¡No lo puedo creer!',
            author: 'Carolina T., 38 años',
            location: 'Mendoza, Argentina'
          }, {
            text: 'Mis compañeras me preguntan cómo hago para tener todo tan prolijo. Les recomendé el pack a todas.',
            author: 'Soledad R., 42 años',
            location: 'Rosario, Argentina'
          }].map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col" data-id="element-158">
                <div className="flex text-yellow-400 mb-4" data-id="element-159">
                  {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} size={16} fill="currentColor" data-id="element-160" />)}
                </div>
                <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-161">
                  "{t.text}"
                </p>
                <div className="mt-auto" data-id="element-162">
                  <p className="font-bold text-gray-900" data-id="element-163">{t.author}</p>
                  <p className="text-sm text-gray-500" data-id="element-164">{t.location}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 13. FAQ SECTION */}
      <section className="bg-white py-10 px-4 md:px-6" data-id="element-165">
        <div className="max-w-3xl mx-auto" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-8" data-id="element-167">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-168">
            {[{
            q: '¿En qué formato recibo el material?',
            a: '100% digital: PDF descargables listos para usar.'
          }, {
            q: '¿Puedo imprimir los cuadernillos?',
            a: 'Sí, sin restricciones.'
          }, {
            q: '¿Para qué grados sirve?',
            a: 'De 1.º a 6.º grado de primaria.'
          }, {
            q: '¿Necesito materiales especiales?',
            a: 'No. Está diseñado para recursos accesibles y habituales en primaria.'
          }, {
            q: '¿Cuánto tarda en llegar?',
            a: 'Acceso inmediato tras la compra.'
          }].map((item, i) => <FaqItem key={i} question={item.q} answer={item.a} data-id="element-169" />)}
          </div>
        </div>
      </section>

      {/* 14. FINAL CTA SECTION */}
      <section className="bg-gray-900 text-white py-12 px-4 md:px-6 text-center" data-id="element-170">
        <div className="max-w-3xl mx-auto" data-id="element-171">
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-172">
            ¿Lista para transformar tu año escolar?
          </h2>
          <p className="text-xl text-gray-300 mb-6" data-id="element-173">
            Unite a cientos de maestras que ya organizaron su año sin estrés.
          </p>
          <a href={LINKS.MAIN_CHECKOUT} target="_blank" rel="noopener noreferrer" className="inline-block bg-[#27ae60] hover:bg-[#219a52] text-white text-2xl md:text-4xl font-black py-6 px-10 md:px-16 rounded shadow-[0_4px_0_rgb(24,120,60)] active:shadow-none active:translate-y-[4px] transition-all transform hover:scale-105 animate-pulse-slow" data-id="element-174">
            👉 QUIERO EMPEZAR AHORA
          </a>
        </div>
      </section>

      {/* 15. FOOTER */}
      <footer className="bg-gray-100 py-8 px-4 text-center text-gray-500 text-sm" data-id="element-175">
        <div className="max-w-4xl mx-auto" data-id="element-176">
          <p className="font-bold text-gray-700 mb-2" data-id="element-177">
            MEGA PACK MATEMÁTICA LISTA™
          </p>
          <p className="mb-4" data-id="element-178">
            © 2026 Mega Pack Matemática Lista™. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-4" data-id="element-179">
            <span className="cursor-pointer hover:text-gray-900" data-id="element-180">Términos</span>
            <span data-id="element-181">·</span>
            <span className="cursor-pointer hover:text-gray-900" data-id="element-182">
              Privacidad
            </span>
            <span data-id="element-183">·</span>
            <span className="cursor-pointer hover:text-gray-900" data-id="element-184">Soporte</span>
          </div>
        </div>
      </footer>
    </div>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-185">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-186">
        <span className="font-bold text-gray-900 text-lg" data-id="element-187">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-188" />
      </button>
      <div className={`bg-white transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-189">
        <p className="p-5 text-gray-600 border-t border-gray-100" data-id="element-190">{answer}</p>
      </div>
    </div>;
}